export default __webpack_public_path__ + "static/media/patient_man.2f10a497.svg";